/**
 * SubmitButton Component
 * Button to submit captured images for classification
 * 
 * Requirements: 2.4, 2.5, 3.2
 */

import './SubmitButton.css';

export interface SubmitButtonProps {
  disabled: boolean;
  isSubmitting: boolean;
  imageCount: number;
  onClick: () => void;
  insufficientCredits?: boolean;
  creditsNeeded?: number;
  className?: string;
}

function SubmitButton({ disabled, isSubmitting, imageCount, onClick, insufficientCredits, creditsNeeded, className }: SubmitButtonProps) {
  const getTitle = () => {
    if (insufficientCredits && creditsNeeded) {
      return `Insufficient credits. You need ${creditsNeeded} credit${creditsNeeded !== 1 ? 's' : ''} to submit ${imageCount} image${imageCount !== 1 ? 's' : ''}. Please purchase more credits or upgrade your subscription.`;
    }
    if (disabled && !isSubmitting) {
      return 'Capture at least one image to submit';
    }
    return `Submit ${imageCount} image${imageCount !== 1 ? 's' : ''} for classification`;
  };

  return (
    <button
      className={`submit-button ${className || ''}`}
      onClick={onClick}
      disabled={disabled || isSubmitting}
      aria-label={getTitle()}
      title={getTitle()}
    >
      {isSubmitting ? (
        <>
          <svg
            className="submit-button-spinner"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10" opacity="0.25" />
            <path d="M12 2a10 10 0 0110 10" opacity="0.75" />
          </svg>
          <span>Processing...</span>
        </>
      ) : (
        <>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="9 11 12 14 22 4" />
            <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
          </svg>
          <span>
            Submit {imageCount > 0 && `(${imageCount})`}
          </span>
        </>
      )}
    </button>
  );
}

export default SubmitButton;
